module.exports = __webpack_public_path__ + "static/media/youtube.dc361033.svg";